<app-modal-base
  [title]="dialogTitle"
  (onSubmitEvent)="onSubmit()"
  [loading]="loading"
  [isDisabled]="form.invalid"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center flex-column">
      <form [formGroup]="form">
        <div>
          <app-input
            [label]="'dpeNumber'"
            [formControl]="form_dpeNumber"
          ></app-input>
        </div>
      </form>
      <p class="details">
        A la validation, une synchronisation des données publiques sera lancée
        pour récupérer les informations du DPE.
      </p>
    </div>
  </div>
</ng-template>
